<mat-dialog-content>
  <form [formGroup]="articleForm">
    <h2>
      <strong>{{ 'Register Article' | translate }}</strong>
    </h2>
    <div class="text-margin">
      <span
        ><strong>{{ 'Product code' | translate }}:</strong></span
      >
      <input
        class="form-control"
        type="text"
        placeholder="{{ 'Code' | translate }}"
        formControlName="code"
      />
      @if (textValid('code')) {
        <span class="form-text text-danger">{{
          'You must enter a product code, with no blank spaces.' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Product description' | translate }}:</strong></span
      >
      <input
        class="form-control"
        type="text"
        placeholder="{{ 'Description' | translate }}"
        formControlName="description"
      />
      @if (textValid('description')) {
        <span class="form-text text-danger">{{
          'You must type a description' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Presentation' | translate }}:</strong></span
      >
      <input
        class="form-control"
        type="number"
        step="0.01"
        placeholder="{{ 'Presentation' | translate }}"
        formControlName="presentation"
      />
      @if (textValid('presentation')) {
        <span class="form-text text-danger">{{
          'You must type a product presentation' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Price' | translate }}</strong></span
      >
      <input
        class="form-control"
        type="number"
        placeholder="{{ 'Price' | translate }}"
        formControlName="price"
      />
      @if (textValid('price')) {
        <span class="form-text text-danger">{{
          'You must type a correct price' | translate
        }}</span>
      }
    </div>

    @if (!isCompoundArticle()) {
      <div class="text-margin">
        <span
          ><strong>{{ 'Quantity' | translate }}:</strong></span
        >
        <input
          class="form-control"
          type="number"
          placeholder="{{ 'Quantity' | translate }}"
          formControlName="quantity"
        />
        @if (textValid('quantity')) {
          <span class="form-text text-danger">{{
            'You must type a correct quantity' | translate
          }}</span>
        }
      </div>
    }

    <div class="text-margin">
      <span
        ><strong>{{ 'Group' | translate }}:</strong></span
      >
      <select class="form-control" formControlName="group">
        <option selected value="">{{ 'Select group' | translate }}</option>
        @for (group of grupoartList; track group) {
          <option [ngValue]="group">
            {{ group.nombre }} - {{ group.presentations[0].value }}
          </option>
        }
      </select>
      @if (textValid('group')) {
        <span class="form-text text-danger">{{
          'You must select a group' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Unit' | translate }}:</strong></span
      >
      <select class="form-control" formControlName="unitBilly">
        <option selected value="">{{ 'Select unit' | translate }}</option>
        @for (unit of unitsList; track unit) {
          <option [ngValue]="unit">
            {{ unit.description }}
          </option>
        }
      </select>
      @if (textValid('unitBilly')) {
        <span class="form-text text-danger">{{
          'You must select a unit' | translate
        }}</span>
      }
    </div>
    @if (!isCompoundArticle()) {
      <div class="text-margin">
        <span
          ><strong>{{ 'Packaging Unit' | translate }}:</strong></span
        >
        <select class="form-control" formControlName="packagingUnit">
          <option [ngValue]="null">
            {{ 'Same as base unit' | translate }}
          </option>
          @for (unit of unitsList; track unit) {
            <option [ngValue]="unit">
              {{ unit.description }}
            </option>
          }
        </select>
        <small class="form-text text-muted">
          {{ 'Optional: Unit for purchases and packaging' | translate }}
        </small>
      </div>
      @if (articleForm.value.packagingUnit?.id_unit) {
        <div class="text-margin">
          <span
            ><strong>{{ 'Packaging Factor' | translate }}:</strong>
            @if (isPackagingFactorLocked) {
              <span class="badge-standard-conversion">
                {{ 'Standard conversion' | translate }}
              </span>
            } @else {
              <span class="badge-custom-factor">
                {{ 'Custom factor' | translate }}
              </span>
            }
          </span>
          <div class="packaging-factor-container">
            <input
              class="form-control packaging-factor-input"
              type="number"
              min="0.01"
              step="1"
              formControlName="packagingFactor1"
              placeholder="1"
            />
            <span class="packaging-factor-operator">×</span>
            <input
              class="form-control packaging-factor-input"
              type="number"
              min="0.01"
              step="1"
              formControlName="packagingFactor2"
              placeholder="1"
            />
            <span class="packaging-factor-operator">=</span>
            <input
              class="form-control packaging-factor-result"
              type="text"
              [value]="packagingFactorTotal"
              readonly
              disabled
            />
          </div>
          <small class="form-text text-muted">
            {{
              'Example: 2 × 12 = 24 (2 packages of 12 units each)' | translate
            }}
          </small>
        </div>
      }
    }
    <div class="text-margin">
      <span
        ><strong>{{ 'Type' | translate }}:</strong></span
      >
      <select class="form-control" formControlName="type">
        <option selected value="">{{ 'Select type' | translate }}</option>
        @for (type of typesList; track type) {
          <option [ngValue]="type">
            {{ type.description }}
          </option>
        }
      </select>
      @if (textValid('type')) {
        <span class="form-text text-danger">{{
          'You must select a type' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Tax' | translate }}:</strong></span
      >
      <select class="form-control" formControlName="tax">
        <option selected value="">{{ 'Select tax' | translate }}</option>
        @for (tax of taxesList; track tax) {
          <option [ngValue]="tax">{{ tax.type }} - ({{ tax.value }}%)</option>
        }
      </select>
      @if (textValid('tax')) {
        <span class="form-text text-danger">{{
          'You must select a tax' | translate
        }}</span>
      }
    </div>

    @if (!isCompoundArticle()) {
      <div class="text-margin">
        <span
          ><strong>{{ 'Warehouse' | translate }}:</strong></span
        >
        <select class="form-control" formControlName="warehouse">
          <option selected value="">
            {{ 'Select warehouse' | translate }}
          </option>
          @for (warehouse of warehouseList; track warehouse) {
            <option [ngValue]="warehouse">
              {{ warehouse.nombre }}
            </option>
          }
        </select>
        @if (textValid('warehouse')) {
          <span class="form-text text-danger">{{
            'You must select a warehouse' | translate
          }}</span>
        }
      </div>
    }

    <div class="text-margin">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        "
      >
        <span
          ><strong>{{ 'Alternative Codes' | translate }}:</strong></span
        >
        <button
          type="button"
          mat-raised-button
          color="primary"
          (click)="openAlternativeCodeDialog()"
          style="height: 36px"
        >
          <mat-icon>add</mat-icon>
          {{ 'Add Code' | translate }}
        </button>
      </div>

      @if (alternativeCodesList.length > 0) {
        <div style="overflow-x: auto; margin-bottom: 15px">
          <table class="table table-sm table-bordered">
            <thead class="thead-light">
              <tr>
                <th>{{ 'Code' | translate }}</th>
                <th>{{ 'Provider' | translate }}</th>
                <th>{{ 'Unit' | translate }}</th>
                <th>{{ 'Packaging' | translate }}</th>
                <th>{{ 'Factor' | translate }}</th>
                <th>{{ 'Description' | translate }}</th>
                <th style="width: 100px">{{ 'Actions' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (code of alternativeCodesList; track $index) {
                <tr>
                  <td>{{ code.alternative_code }}</td>
                  <td>{{ getProviderName(code) }}</td>
                  <td>{{ getUnitName(code) }}</td>
                  <td>
                    {{ code.packaging_quantity || 1 }} ×
                    {{ code.units_per_package || 1 }}
                  </td>
                  <td>{{ code.conversion_factor || 1 }}</td>
                  <td>{{ code.description || '-' }}</td>
                  <td>
                    <button
                      type="button"
                      mat-icon-button
                      color="primary"
                      (click)="openAlternativeCodeDialog(code, $index)"
                      matTooltip="{{ 'Edit' | translate }}"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      type="button"
                      mat-icon-button
                      color="warn"
                      (click)="removeAlternativeCode($index)"
                      matTooltip="{{ 'Delete' | translate }}"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <p class="text-muted" style="font-style: italic">
          {{ 'No alternative codes added yet' | translate }}
        </p>
      }

      <small class="form-text text-muted">
        {{
          'Alternative codes help identify the same article with different supplier codes or packaging configurations'
            | translate
        }}
      </small>
    </div>

    @if (!isCompoundArticle()) {
      <div>
        <span
          ><strong>{{ 'Quantity Initial' | translate }}:</strong></span
        >
        <input
          class="form-control"
          placeholder="0"
          type="number"
          formControlName="quantityInitial"
        />
        @if (textValid('quantityInitial')) {
          <span class="form-text text-danger">{{
            'You must type a correct quantity' | translate
          }}</span>
        }
      </div>
      <div>
        <span
          ><strong>{{ 'Value Initial' | translate }}:</strong></span
        >
        <input
          class="form-control"
          placeholder="0"
          type="number"
          formControlName="valueInitial"
        />
        @if (textValid('valueInitial')) {
          <span class="form-text text-danger">{{
            'You must type a correct value' | translate
          }}</span>
        }
      </div>
    }

    <!-- Compound Article Section -->
    @if (isCompoundArticle()) {
      <div class="compound-article">
        <h3 class="compound-article__title">
          {{ 'inventory.compoundArticles.modals.register.title' | translate }}
        </h3>

        <!-- Sub Articles Selection -->
        @if (articleForm.get('components'); as componentsControl) {
          <div class="compound-article__subarticles mb-4">
            <p>
              {{
                'inventory.compoundArticles.modals.register.subArticles.description'
                  | translate
              }}
            </p>

            <div formArrayName="components">
              @for (
                componentGroup of componentsFormArray.controls;
                track componentGroup;
                let i = $index
              ) {
                <div class="subarticle-row" [formGroupName]="i">
                  <!-- Article Search Autocomplete -->
                  <mat-form-field
                    appearance="fill"
                    class="subarticle-item w-100"
                  >
                    <mat-label>{{
                      'inventory.compoundArticles.modals.register.subArticles.searchArticle'
                        | translate
                    }}</mat-label>

                    <input
                      matInput
                      formControlName="articleSearch"
                      placeholder="{{
                        'inventory.compoundArticles.modals.register.subArticles.searchPlaceholder'
                          | translate
                      }}"
                      [matAutocomplete]="articleAuto"
                    />

                    <mat-autocomplete
                      #articleAuto="matAutocomplete"
                      (optionSelected)="
                        onArticleSelected($event.option.value, i)
                      "
                    >
                      @for (
                        article of filteredArticles[i] | async;
                        track article.id_articulo
                      ) {
                        <mat-option [value]="article">
                          {{ article.descripcion }} - {{ article.codigo }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>

                  <!-- Quantity Input -->
                  <mat-form-field
                    appearance="fill"
                    class="subarticle-quantity w-100"
                  >
                    <mat-label>{{
                      'inventory.compoundArticles.modals.register.subArticles.quantity'
                        | translate
                    }}</mat-label>

                    <input
                      matInput
                      type="number"
                      formControlName="quantity"
                      step="0.001"
                      min="0.001"
                      placeholder="{{
                        'inventory.compoundArticles.modals.register.subArticles.quantity'
                          | translate
                      }}"
                    />
                  </mat-form-field>

                  <!-- Unit Select -->
                  <mat-form-field
                    appearance="fill"
                    class="subarticle-unit w-100"
                  >
                    <mat-label>{{ 'Unit' | translate }}</mat-label>
                    <mat-select formControlName="unit">
                      @for (unit of unitsList; track unit.id_unit) {
                        <mat-option [value]="unit.id_unit">
                          {{ unit.id_second }} - {{ unit.description }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <div
                    class="d-flex align-items-center justify-content-around mb-3"
                  >
                    <!-- Add SubArticle Button -->
                    <button
                      mat-raised-button
                      type="button"
                      class="subarticle-add"
                      (click)="addSubArticle()"
                    >
                      <mat-icon>add_circle</mat-icon>
                      {{
                        'inventory.compoundArticles.modals.register.subArticles.add'
                          | translate
                      }}
                    </button>

                    <!-- Remove SubArticle Button -->
                    <button
                      mat-raised-button
                      type="button"
                      class="subarticle-remove"
                      [disabled]="componentsFormArray.length === 1"
                      (click)="removeSubArticle(i)"
                    >
                      <mat-icon>remove_circle</mat-icon>
                      {{
                        'inventory.compoundArticles.modals.register.subArticles.remove'
                          | translate
                      }}
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- Recipe Quantity -->
        @if (articleForm.get('recipeQuantity'); as componentsControl) {
          <mat-form-field
            appearance="fill"
            class="compound-article__recipe-quantity w-100 mt-2 mb-3"
          >
            <mat-label>{{
              'inventory.compoundArticles.modals.register.recipeQuantity'
                | translate
            }}</mat-label>
            <input
              matInput
              type="number"
              formControlName="recipeQuantity"
              step="0.001"
              min="0.001"
              placeholder="{{
                'inventory.compoundArticles.modals.register.recipeQuantity'
                  | translate
              }}"
            />
            <mat-hint>{{
              'inventory.compoundArticles.modals.register.recipeQuantityHint'
                | translate
            }}</mat-hint>
          </mat-form-field>
        }
        <!-- End Recipe Quantity-->

        <!-- Compouund Article Check Produce -->
        <div class="compound-article__produce mt-4">
          <mat-checkbox
            [(ngModel)]="produceCompoundArticleCheck"
            [ngModelOptions]="{ standalone: true }"
          >
            {{
              'inventory.compoundArticles.modals.register.produceQuestion'
                | translate
            }}
          </mat-checkbox>
        </div>
        <!-- End Compouund Article Check Produce -->
      </div>
    }
  </form>

  <div
    class="row"
    style="padding-left: 20px; margin-top: 10px"
    id="buttons-div"
  >
    <div class="col" id="buttons">
      <button (click)="register()" mat-raised-button>
        {{ 'Register' | translate }}
      </button>
    </div>
    <div class="col" id="buttons">
      <button mat-raised-button [mat-dialog-close]>
        {{ 'Cancel' | translate }}
      </button>
    </div>
  </div>
</mat-dialog-content>

<ngx-spinner
  type="ball-scale-multiple"
  template="<img src='../../../../../../assets/gif/V1-Insight-Icon-for-gif-2.gif' />"
  bdColor="rgba(51,51,51,0.8)"
>
  <p style="font-size: 20px; color: #ffffff">{{ 'Loading...' | translate }}</p>
</ngx-spinner>
